import { Box, Text, Grid } from "@chakra-ui/react";
import React, { useContext, useState } from "react";
import { api } from "../../services/api";
import { CityContext } from '../../Context/CityContext';
import { useLocation } from 'react-router-dom';
import { FilterChip } from "../FilterChip";

const beerTypeOptions = [
  "PILSEN","IPA","APA","German Pils","Low Carb","Hop Lager",
  "Pale Ale","Witbier","Session Ipa","Double IPA","BROWN ALE",
  "HOP LAGER","LAGER","BLOND ALE","Microcervejarias",
];

const brandOptions = [
  "HOOG BIER","BACKER","Backer","VERACE","Verace","ALBANOS","Albanos",
  "BOHEMIA","Armadillo","Heineken","Évora","LAUT","Laut",
  "Cervejaria Mutuca","MillsBrewery","Sapatona cervejaria","CAPITÃO SENRA","ORIGINAL",
];

const SectionLabel = ({ children }) => (
  <Text
    fontSize="11px"
    fontWeight="800"
    color="rgba(0,74,51,0.55)"
    letterSpacing="0.08em"
    textTransform="uppercase"
    mb="10px"
  >
    {children}
  </Text>
);

export function BeerFilters(props) {
  const location = useLocation();
  const [beerTypes, setBeerTypes] = useState([]);
  const [beerBrands, setBeerBrands] = useState([]);
  const { cityParam } = useContext(CityContext);

  async function filterProducts(brands, types) {
    let url = `/api/v1/products?city_id=${cityParam}`;
    if (brands.length > 0) url += `&beer_brands=${brands.join(',')}`;
    if (types.length > 0) url += `&beer_types=${types.join(',')}`;
    if (types.length === 0 && brands.length === 0) {
      const filter = new URLSearchParams(location.search).get("filter");
      if (filter) url += `&filter=${filter}`;
    }
    const response = await api.get(url);
    props.setProducts(response.data.products);
  }

  function toggleType(type) {
    const updated = beerTypes.includes(type)
      ? beerTypes.filter(t => t !== type)
      : [...beerTypes, type];
    setBeerTypes(updated);
    filterProducts(beerBrands, updated);
  }

  function toggleBrand(brand) {
    const updated = beerBrands.includes(brand)
      ? beerBrands.filter(b => b !== brand)
      : [...beerBrands, brand];
    setBeerBrands(updated);
    filterProducts(updated, beerTypes);
  }

  return (
    <>
      <SectionLabel>Tipos</SectionLabel>
      <Grid templateColumns="repeat(2,1fr)" gap="8px" mb="20px">
        {beerTypeOptions.map((t, i) => (
          <FilterChip key={i} label={t} isActive={beerTypes.includes(t)} onClick={() => toggleType(t)} />
        ))}
      </Grid>

      <Box h="1px" bg="rgba(0,74,51,0.08)" mb="20px" />

      <SectionLabel>Marcas</SectionLabel>
      <Grid templateColumns="repeat(2,1fr)" gap="8px">
        {brandOptions.map((b, i) => (
          <FilterChip key={i} label={b} isActive={beerBrands.includes(b)} onClick={() => toggleBrand(b)} />
        ))}
      </Grid>
    </>
  );
}
